import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		relativeContainer: {
			position: 'relative',
		},
		filterButtonContainer: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-end',
		},
		subHeaderContent: {
			marginBottom: '10px',
		},
		btnSection: {
			position: 'relative',
			flexFlow: 'column',
		},
	})
